<template>
  <a-layout class="s_bf">
    <a-card :bordered="false">
      <a-form ref="ruleForm" :rules="rules" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :scrollToFirstError="true">
        <a-form-item ref="name" label="标题" name="name" required>
          <a-input v-model:value="form.name" placeholder='请输入活动名称' style="width:400px" :maxlength="20" :suffix="form.name.length+'/20'"></a-input>
        </a-form-item>
        <!--  -->
        <a-form-item label="时间要求" name='end_time' required >
          <a-range-picker v-model:value="time" :show-time="{ format: 'YYYY-MM-DD' }" style="width:400px" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
         <a-form-item label="规则说明" name='rule'>
          <quill v-model:value="form.rule" :showImg="true" :content="form.rule?JSON.parse(JSON.stringify(form.rule)):''" :height="600" />
        </a-form-item>
        <a-button type="primary" @click="next()" class="marigin_lr_auto">下一步</a-button>
      </a-form>
    </a-card> 
  </a-layout>
</template>

<script>
  
  import {
  } from "@ant-design/icons-vue";
import {
fristcontracting,
detailcontracting,
editcontracting
} from "@/api/guide";
import { inject, provide, ref,onMounted } from "vue";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
const def = {
   name: "",
   rule:"",
};
const rules = {
  name: [
    {
      required: true,
      message: "请输入活动名称",
    },
  ],
  end_time:[
    {
      required: true,
      message: "请设置时间范围",
    },
  ],
};
export default {
  
  components: {
    },
  props: {
    id: {
      type: Number,
      default: () => {
        return null;
      },
    },
    actionType:{ //操作类型
      type:String
    },
    isAction:{ // 是否已经下一步过
      type:Boolean
    }
  },
  setup(props, { emit }) {
    console.log(props.id);
    const labelCol = { span: 3 };
    const wrapperCol = { span: 16 };
    const momentTime = inject("momentTime");
    const form = ref({...def});
    const time = ref(null);
    // const ruleForm = ref();
    // 修改时间
    const onChange = (e) => {
      form.value.start_time = e[0];
      form.value.end_time = e[1];
    };
    // 获取详情
    const detail = async () => {
      let result = await detailcontracting({id:props.id})
        .then((res) => res.data)
        .catch((error) => error);
        console.log(result);
      if (iscode(result)) {
        form.value = result.data;
          time.value = [result.data.start_time, result.data.end_time];
      } else {
        message.error(result.message);
      }
    };
    // 下一步
    const next = () => {
      if (props.id) {
        update();
      } else {
        create();
      }
    };
    // 创建
    const create = async() => {
        let result = await fristcontracting({
          ...form.value,
        })
          .then((res) => res.data)
          .catch((error) => error);
        console.log(result);
        if (iscode(result, true)) {
          emit("setpsOneDone", {
            ...form.value,
             id: result.data.id,
          });
        }
    };
    // 修改
    const update =async () => {
        let result = await editcontracting({id:props.id,...form.value})
          .then((res) => res.data)
          .catch((error) => error);
        if (iscode(result, true)) {
          emit("setpsOneDone", {
            ...form.value,
            id: result.data.id,
          });
        }
    };
        onMounted(() => {
          // if(){}
        // detail();
    });
    return {
      form,
      rules,
      time,
      labelCol,
      wrapperCol,
      onChange,
      create,
      update,
      detail,
      next,
    };
  },
};
</script>